// Third Party
import React from 'react';

// Components
import EditPortfolioScreenerHeader from './EditPortfolioScreenerHeader';
import { AdvancedSearch } from '../search';

// Types
import Fund from '@/types/fund';
import AdvancedSearchItem from '@/types/advanced-search-item';
import { MultiselectAction } from '@/types/data-table';

// Utils
import { ADVANCED_SEARCH_OPTIONS, PROXY_OPTION } from '@/utils/constants';

type Props = {
  classicVersionOnly?: boolean;
  className?: string;
  title: string;
  onClose: () => void;
  onExpand?: () => void;
  isExpanded: boolean;
  hideExpandButton?: boolean;
  onAddItem: (fund: Fund) => void;
  customTableActions?: MultiselectAction<AdvancedSearchItem>[] | JSX.Element[];
  selectedOption?: ADVANCED_SEARCH_OPTIONS;
  proxyOption?: PROXY_OPTION;
  showInlineAdd?: boolean;
  onCompareAlternatives?: () => void;

  // Legacy props
  onArrowClick?: (fund: Fund) => void;
  hideSaveFund?: boolean;
};

const EditPortfolioScreener = (props: Props) => {
  const {
    title,
    onClose,
    onExpand,
    hideExpandButton,
    hideSaveFund,
    isExpanded,
    onArrowClick,
    onAddItem,
    customTableActions,
    selectedOption,
    proxyOption,
    showInlineAdd,
    onCompareAlternatives,
  } = props;

  return (
    <>
      <EditPortfolioScreenerHeader title={title} onClose={onClose} onExpand={onExpand} isExpanded={isExpanded} hideExpandButton={hideExpandButton} />
      <AdvancedSearch
        classicVersionOnly={props.classicVersionOnly}
        insideModal
        hideSearchOptions
        hideCompareAllAlternatives
        showInlineAdd={showInlineAdd}
        selectedOption={selectedOption}
        canSelect={isExpanded && !showInlineAdd}
        compact={!isExpanded}
        minimizedFiltersToShow={!isExpanded ? 2 : undefined}
        customTableActions={customTableActions}
        proxyOption={proxyOption}
        onAddItem={onAddItem}
        onCompareAlternatives={onCompareAlternatives}
        // Legacy props
        overrideShowArrow
        onArrowClick={!isExpanded && onArrowClick ? onArrowClick : undefined}
        hideSaveFund={hideSaveFund}
      />
    </>
  );
};

export default EditPortfolioScreener;
